import { Pipe, PipeTransform, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from '../../services/TranslationService';

@Pipe({
  name: 'translate',
  pure: false,
  standalone: true
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private currentValue = '';
  private lastKey = '';
  private lastParams: any = null;
  private subscription: Subscription;


  constructor(
    private translationService: TranslationService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.subscription = this.translationService.translations$.subscribe(() => {
      this.updateValue(this.lastKey, this.lastParams);
      this.changeDetector.markForCheck();
    });
  }

  transform(key: string, params?: any): string {
    if (!key) return '';

    if (key === this.lastKey && this.areParamsEqual(params, this.lastParams)) {
      return this.currentValue;
    }

    this.lastKey = key;
    this.lastParams = params;
    this.updateValue(key, params);

    return this.currentValue;
  }

  private updateValue(key: string, params?: any): void {
    this.currentValue = this.translationService.instant(key, params);
  }


  private areParamsEqual(a: any, b: any): boolean {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
